// import { Box, Card, TextField, Typography } from "@mui/material";
// import { useSnackbar } from "notistack";
// import React, { useState } from "react";
// import { Helmet } from "react-helmet";
// import OtpInput from "react-otp-input";
// import { useDispatch, useSelector } from "react-redux";
// import { Link, useNavigate } from "react-router-dom";
// import AppButton from "../../components/app-button/AppButton";
// import AppLogo from "../../components/app-logo/AppLogo";
// import { SITE_TITLE } from "../../constants/Site";
// import {
//   login,
//   updateName,
//   verifyOtp,
// } from "../../reduxStore/slices/authSlice";
// import { getStoreById } from "../../reduxStore/slices/storeSlice";
// import { useNotify } from "../../utils/snackbarUtils";
// import "./Login.css";

// function Login() {
//   const { enqueueSnackbar } = useSnackbar();
//   const { showSuccess, showError, handleApiError } = useNotify();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const {
//     loading: isLoading,
//     user,
//     otpDetails,
//   } = useSelector((state) => state.auth);

//   const [step, setStep] = useState(1);
//   const [otp, setOtp] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [name, setName] = useState("");
//   const [countryCode] = useState("91");
//   const [timerCount, setTimer] = useState(60);

//   const otpReferenceId = otpDetails?.otp_reference_id;
//   const userRoleCode = user?.user_role_code;

//   const handleOtpChange = (val) => {
//     setOtp(val);
//   };

//   const handleLoginClick = async () => {
//     if (!mobile) {
//       showError("Please enter Mobile No.");
//       return;
//     }
//     try {
//       setOtp("");
//       const res = await dispatch(
//         login({ country_code: countryCode, mobile_no: mobile })
//       ).unwrap();

//       setStep(2);
//       setTimer(60);
//       handleSetTimer();
//       showSuccess(res?.message);
//     } catch (err) {
//       handleApiError(err);
//     }
//   };

//   const handleOtpClick = async () => {
//     if (!otp) {
//       showError("Please enter Otp.");
//       return;
//     }
//     try {
//       const res = await dispatch(
//         verifyOtp({
//           country_code: countryCode,
//           mobile_no: mobile,
//           otp,
//           otp_reference_id: otpReferenceId,
//         })
//       ).unwrap();
//       if (res?.storeId) {
//         await dispatch(getStoreById({ storeId: res.storeId }));
//       }

//       if (res?.userName && res?.userName !== "") {
//         navigateUser("owner");
//         enqueueSnackbar("Successfully logged in.", { variant: "success" });
//       } else {
//         setStep(3);
//       }
//     } catch (err) {
//       handleApiError(err);
//     }
//   };

//   const handleNameClick = async () => {
//     try {
//       await dispatch(updateName(name)).unwrap();
//       navigateUser(userRoleCode);
//       enqueueSnackbar("Successfully logged in.", { variant: "success" });
//     } catch (err) {
//       handleApiError(err);
//     }
//   };

//   const navigateUser = (userRole) => {
//     switch (userRole) {
//       case "owner":
//         return navigate("/app/home", { replace: true });
//       case "user":
//       case "agent":
//       case "super_admin":
//       default:
//         return;
//     }
//   };

//   const handleSetTimer = () => {
//     let interval = setInterval(() => {
//       setTimer((lastTimerCount) => {
//         if (lastTimerCount <= 1) clearInterval(interval);
//         return lastTimerCount - 1;
//       });
//     }, 1000);
//     return () => clearInterval(interval);
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Login | {SITE_TITLE}</title>
//       </Helmet>
//       <Box className="l-page">
//         <Box>
//           <Box className="login-wrap">
//             <Card>
//               <Box>
//                 {/* STEP 1: Enter mobile */}
//                 {step === 1 && (
//                   <Box
//                     className="login-content"
//                     component="form"
//                     onSubmit={(e) => {
//                       e.preventDefault();
//                       handleLoginClick();
//                     }}
//                   >
//                     <AppLogo color="rgb(0, 0, 0)" />
//                     <Typography className="l-heading">Log in</Typography>
//                     <Box>
//                       <TextField
//                         autoComplete="off"
//                         inputProps={{
//                           style: { fontSize: 16, fontWeight: 500 },
//                         }}
//                         fullWidth
//                         autoFocus
//                         value={mobile}
//                         label="Mobile number"
//                         placeholder="Enter Mobile No."
//                         variant="outlined"
//                         onChange={(event) => setMobile(event.target.value)}
//                       />
//                     </Box>
//                     <Box>
//                       <AppButton
//                         disabled={isLoading}
//                         isLoading={isLoading}
//                         onClick={handleLoginClick}
//                         fullWidth
//                         size="large"
//                         variant="contained"
//                       >
//                         Continue
//                       </AppButton>
//                     </Box>
//                     <Box>
//                       <Typography className="l-policy-section">
//                         By continuing, you agree to our{" "}
//                         <Link
//                           to="/terms"
//                           style={{ textDecoration: "underline" }}
//                         >
//                           Terms of Use
//                         </Link>{" "}
//                         and{" "}
//                         <Link
//                           to="/privacy"
//                           style={{ textDecoration: "underline" }}
//                         >
//                           Privacy Policy
//                         </Link>
//                         .
//                       </Typography>
//                     </Box>
//                   </Box>
//                 )}

//                 {/* STEP 2: Verify OTP */}
//                 {step === 2 && (
//                   <Box
//                     className="login-content"
//                     component="form"
//                     onSubmit={(e) => {
//                       e.preventDefault();
//                       handleOtpClick();
//                     }}
//                   >
//                     <AppLogo color="rgb(0, 0, 0)" />
//                     <Box>
//                       <Typography className="l-heading">Verify code</Typography>
//                       <Typography>
//                         <span style={{ color: "gray", fontSize: 14 }}>
//                           Enter verification code sent to you at
//                         </span>{" "}
//                         +91-{mobile}
//                         <Link
//                           style={{
//                             paddingLeft: 5,
//                             fontSize: 14,
//                             color: "#146eb4",
//                           }}
//                           onClick={() => setStep(1)}
//                         >
//                           Edit
//                         </Link>
//                       </Typography>
//                     </Box>
//                     <Box>
//                       <Box className="verify-help-text">
//                         <Typography className="f-14">Code</Typography>
//                         <Typography className="f-14">
//                           Didn't get the code?
//                           <Link
//                             className="resend-link"
//                             onClick={timerCount <= 0 ? handleLoginClick : null}
//                             style={{
//                               color: timerCount > 0 ? "#ccc" : "#146eb4",
//                               cursor: timerCount > 0 ? "default" : "pointer",
//                               marginLeft: 5,
//                             }}
//                           >
//                             Resend OTP {timerCount > 0 && timerCount}
//                           </Link>
//                         </Typography>
//                       </Box>

//                       <OtpInput
//                         shouldAutoFocus
//                         inputStyle="otp-input-style"
//                         focusStyle="otp-focus-style"
//                         value={otp}
//                         onChange={handleOtpChange}
//                         numInputs={6}
//                         isInputNum
//                       />
//                     </Box>
//                     <Box>
//                       <AppButton
//                         disabled={isLoading}
//                         isLoading={isLoading}
//                         onClick={handleOtpClick}
//                         fullWidth
//                         size="large"
//                         variant="contained"
//                       >
//                         Verify
//                       </AppButton>
//                     </Box>
//                   </Box>
//                 )}

//                 {/* STEP 3: Enter name */}
//                 {step === 3 && (
//                   <Box className="login-content">
//                     <AppLogo color="rgb(0, 0, 0)" />
//                     <Box>
//                       <TextField
//                         autoComplete="off"
//                         inputProps={{
//                           style: { fontSize: 16, fontWeight: 500 },
//                         }}
//                         fullWidth
//                         autoFocus
//                         value={name}
//                         label="Enter your full name"
//                         variant="outlined"
//                         onChange={(event) => setName(event.target.value)}
//                       />
//                     </Box>
//                     <Box>
//                       <AppButton
//                         disabled={isLoading}
//                         isLoading={isLoading}
//                         onClick={handleNameClick}
//                         fullWidth
//                         size="large"
//                         variant="contained"
//                       >
//                         Continue
//                       </AppButton>
//                     </Box>
//                   </Box>
//                 )}
//               </Box>
//             </Card>
//           </Box>
//         </Box>
//       </Box>
//     </>
//   );
// }

// export default Login;

import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AppButton from "../../components/app-button/AppButton";
import Iconify from "../../components/iconify/Iconify";
import SiteLogo from "../../components/site-logo/SiteLogo";
import { SITE_TITLE } from "../../constants/Site";
import {
  login,
  updateName,
  verifyOtp,
} from "../../reduxStore/slices/authSlice";
import { getStoreById } from "../../reduxStore/slices/storeSlice";
import { useNotify } from "../../utils/snackbarUtils";

export default function Login() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showSuccess, showError, handleApiError } = useNotify();

  const {
    loading: isLoading,
    user,
    otpDetails,
  } = useSelector((state) => state.auth);

  const [isOTPLoading, setIsOTPLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0); // 0 -> enter mobile, 1 -> otp, 2 -> name
  const [mobile, setMobile] = useState("");
  const [countryCode] = useState("91");
  const [otp, setOtp] = useState("");
  const [name, setName] = useState("");
  const [timer, setTimer] = useState(0);
  const timerRef = useRef(null);

  const otpReferenceId = otpDetails?.otp_reference_id;
  const userRoleCode = user?.user_role_code;

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  // Helper: start countdown timer (seconds)
  const startTimer = (secs = 60) => {
    setTimer(secs);
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimer((t) => {
        if (t <= 1) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          return 0;
        }
        return t - 1;
      });
    }, 1000);
  };

  // Step actions
  const handleRequestOtp = async () => {
    if (!mobile || mobile.toString().trim().length < 6) {
      showError("Please enter a valid mobile number.");
      return;
    }
    try {
      setOtp("");
      const res = await dispatch(
        login({ country_code: countryCode, mobile_no: mobile })
      ).unwrap();
      showSuccess(res?.message || "OTP sent.");
      setActiveStep(1);
      startTimer(60);
    } catch (err) {
      handleApiError(err);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp || otp.length < 4) {
      showError("Enter the full verification code.");
      return;
    }
    setIsOTPLoading(true);
    try {
      const res = await dispatch(
        verifyOtp({
          country_code: countryCode,
          mobile_no: mobile,
          otp,
          otp_reference_id: otpReferenceId,
        })
      ).unwrap();

      if (res?.storeId) {
        // optional: preload store
        await dispatch(getStoreById({ storeId: res.storeId }));
      }
      // If user has name, navigate; else go to name step
      if (res?.userName && res?.userName !== "") {
        showSuccess("Successfully logged in.");
        navigateUser("owner");
      } else {
        setActiveStep(2);
      }
      setIsOTPLoading(false);
    } catch (err) {
      handleApiError(err);
      setIsOTPLoading(false);
    }
  };

  const handleSetName = async () => {
    if (!name || name.trim().length < 2) {
      showError("Please enter your full name.");
      return;
    }
    try {
      await dispatch(updateName(name)).unwrap();
      showSuccess("Profile saved. Redirecting...");
      navigateUser(userRoleCode);
    } catch (err) {
      handleApiError(err);
    }
  };

  const navigateUser = (userRole) => {
    switch (userRole) {
      case "owner":
        return navigate("/app/home", { replace: true });
      case "user":
      case "agent":
      case "super_admin":
      default:
        return;
    }
  };

  const handleResend = async () => {
    if (timer > 0) return;
    await handleRequestOtp();
  };

  return (
    <>
      <Helmet>
        <title>Login | {SITE_TITLE}</title>
      </Helmet>

      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          background:
            "linear-gradient(180deg, rgba(249,250,251,1) 0%, rgba(242,244,247,1) 100%)",
          py: { xs: 6, md: 10 },
        }}
      >
        <Box
          style={{
            height: "inherit",
            width: "100%",
          }}
        >
          <Grid
            container
            alignItems="center"
            style={{
              height: "inherit",
            }}
          >
            {/* LEFT PANEL */}
            <Grid
              item
              size={{ xs: 12, md: 7, sm: 7 }}
              style={{
                height: "inherit",
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  position: "relative",
                  overflow: "hidden",
                  minHeight: 500,
                }}
              >
                <Box
                  component="img"
                  src="/img/home-banner.jpg"
                  alt="Restaurant POS"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    filter: "brightness(0.4)",
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    px: 5,
                  }}
                >
                  <Typography
                    variant="h3"
                    color="white"
                    fontWeight={800}
                    mb={2}
                  >
                    Run your restaurant on autopilot
                  </Typography>

                  <Typography variant="h6" color="#f0f0f0" mb={3}>
                    Offline-safe billing, order routing, and real-time analytics
                    made for bustling kitchens.
                  </Typography>

                  <Box display="flex" flexDirection="column" gap={2}>
                    {[
                      "Works even when the internet fails",
                      "Lightning fast billing",
                      "Kitchen-safe order printing",
                      "Trusted by 5,000+ restaurants across India",
                    ].map((t, i) => (
                      <Box key={i} display="flex" alignItems="center" gap={1}>
                        <Iconify
                          icon="solar:check-circle-bold"
                          color="#4ade80"
                          width={22}
                        />
                        <Typography color="white" fontWeight={600}>
                          {t}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Grid>

            {/* RIGHT AUTH CARD */}
            <Grid
              item
              size={{ xs: 12, md: 5, sm: 5 }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Card
                elevation={6}
                sx={{
                  p: { xs: 3, md: 5 },
                  borderRadius: 2,
                }}
              >
                <Box sx={{ width: "100%", mb: 2 }}>
                  <SiteLogo showTagline />
                </Box>

                <Box sx={{ mt: 2 }}>
                  {activeStep === 0 && (
                    <Box
                      component="form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleRequestOtp();
                      }}
                      sx={{ display: "grid", gap: 1 }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                        Enter mobile number
                      </Typography>
                      <TextField
                        label="Mobile number"
                        placeholder="Enter Mobile No."
                        value={mobile}
                        onChange={(e) =>
                          setMobile(e.target.value.replace(/\D/g, ""))
                        }
                        inputProps={{ maxLength: 15, inputMode: "numeric" }}
                        fullWidth
                        autoFocus
                        autoComplete="off"
                        helperText="We’ll send an OTP to this number..!"
                      />

                      <AppButton
                        isLoading={isLoading}
                        disabled={isLoading}
                        onClick={handleRequestOtp}
                        fullWidth
                        size="large"
                        variant="contained"
                      >
                        GET OTP
                      </AppButton>
                    </Box>
                  )}

                  {activeStep === 1 && (
                    <Box
                      component="form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleVerifyOtp();
                      }}
                      sx={{ display: "grid", gap: 2 }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 700 }}>
                        Verify your number
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        Enter the 6 digit code sent to +{countryCode}-{mobile}
                        <Button
                          onClick={() => setActiveStep(0)}
                          size="small"
                          sx={{ ml: 1 }}
                        >
                          Edit
                        </Button>
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          my: 1,
                        }}
                      >
                        <OtpInput
                          value={otp}
                          onChange={(val) => setOtp(val)}
                          numInputs={6}
                          isInputNum
                          shouldAutoFocus
                          inputStyle={{
                            width: 50,
                            height: 50,
                            color: "#1a181e",
                            fontWeight: 700,
                            margin: "0 6px",
                            borderRadius: 8,
                            borderWidth: 1,
                            borderStyle: "solid",
                            borderColor: "#d9d9d9",
                            fontSize: 28,
                            textAlign: "center",
                          }}
                          focusStyle={{
                            outline: `2px solid ${theme.palette.primary.main}`,
                            borderColor: "#146eb4",
                          }}
                        />
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                        }}
                      >
                        <AppButton
                          isLoading={isOTPLoading}
                          disabled={isOTPLoading}
                          onClick={handleVerifyOtp}
                          size="large"
                          variant="contained"
                          fullWidth
                        >
                          Verify
                        </AppButton>
                      </Box>

                      <Box sx={{ textAlign: "center" }}>
                        <Button
                          variant="text"
                          onClick={handleResend}
                          disabled={timer > 0 || isLoading}
                          sx={{ fontWeight: 600 }}
                        >
                          {timer > 0 ? `Resend in ${timer}s` : "Resend OTP"}
                        </Button>
                      </Box>

                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Having trouble receiving SMS? Try switching network or
                          request a call.
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {activeStep === 2 && (
                    <Box
                      component="form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleSetName();
                      }}
                      sx={{ display: "grid", gap: 2 }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 700 }}>
                        Complete your profile
                      </Typography>
                      <TextField
                        label="Full name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                        autoFocus
                        helperText="Please enter your full name."
                      />
                      <AppButton
                        isLoading={isLoading}
                        disabled={isLoading}
                        onClick={handleSetName}
                        fullWidth
                        size="large"
                        variant="contained"
                      >
                        Continue
                      </AppButton>
                    </Box>
                  )}
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                  <Typography variant="caption" color="text.secondary">
                    By signing in you accept our <Link to="/terms">Terms</Link>{" "}
                    & <Link to="/privacy">Privacy policy</Link>.
                  </Typography>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
